import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';

/**
 * Loader returns a common loader circle,
 * to be used in components waiting for API response. 
 * @param componentHeight height to define the area the loader should replace
 */
function Loader(props) {
    const { componentHeight, color } = props;
    return (
        <Box className="App-loader" width="100%" height="92.7vh" >
            <Grid container justifyContent={"center"} marginTop="15%">
                
                    <CircularProgress
                        size={componentHeight}
                        style={{
                            '& .MuiCircularProgressCircle': {
                                color: color
                            }
                        }} />
               
            </Grid>
        </Box>
    )
}

Loader.defaultProps = {
    componentHeigh: "45px",
    color: "primary"   

}

export default Loader;